import { render, staticRenderFns } from "./koditem4b.vue?vue&type=template&id=40d6cfbf&scoped=true"
import script from "./koditem4b.vue?vue&type=script&lang=js"
export * from "./koditem4b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6cfbf",
  null
  
)

export default component.exports